import axiosClient from "../../../../../../axiosClient"

export default async (id) => {
    const result = await axiosClient.get(`/pre-check-initial-document-analyze-results/${id}`)
    return result.data
}
